function hasBadEncoding(fieldValue) {
  return fieldValue.includes('�');
}

function checkStringAgainstPattern(fieldValue, patternString) {
  const pattern = new RegExp(patternString);
  return !pattern.test(fieldValue);
}

function validateEntry(entry, key, value, validationPatten) {
  const badEncoding = hasBadEncoding(value);
  const defaultValidation = checkStringAgainstPattern(value, validationPatten);

  return {
    ...entry,
    validationErrors: {
      ...entry.validationErrors,
      [key]: {
        badEncoding,
        defaultValidation
      }
    }
  };
}

module.exports = {
  validateEntry
};
